export default __webpack_public_path__ + "static/media/icon8.6ab428b9.svg";